import { AlertState } from './alertReducer';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

const setAlertState = (
  newState: Omit<AlertState, 'alertsWithId'>,
  id?: string
) => ({
  ...newState,
  type: 'SET_ALERT_STATE',
  id
});
export const clearAlert = (id?: string) =>
  setAlertState(
    {
      alertType: null,
      message: null
    },
    id
  );
export const setError = (message: string, id?: string) =>
  setAlertState(
    {
      alertType: 'error',
      message
    },
    id
  );

export const setInfo = (message: string, id?: string) =>
  setAlertState(
    {
      alertType: 'info',
      message
    },
    id
  );

export const setSuccess = (message: string, id?: string) =>
  setAlertState(
    {
      alertType: 'success',
      message
    },
    id
  );

export const setWarning = (message: string, id?: string) =>
  setAlertState(
    {
      alertType: 'warning',
      message
    },
    id
  );

export const useActions = () => {
  const dispatch: Dispatch<any> = useDispatch();

  return {
    onClose: (id?: string) =>
      dispatch(setAlertState({ alertType: null, message: null }, id))
  };
};
